
const images = document.querySelectorAll<HTMLImageElement>('img[loading="lazy"]');
images.forEach(handleImage);

function handleImage(img: HTMLImageElement) {

    img.classList.add("lazyloading");
    img.classList.remove("lazyload");

    img.addEventListener('load', handleLoaded, { passive: true });
    img.addEventListener('error', handleError, { passive: true });

    if (img.complete) {
        handleLoaded();
    }

    function handleLoaded() {
        img.classList.add("lazyloaded");
        img.classList.remove("lazyloading");
        img.closest('.img-spinner')?.classList.remove('img-spinner');
    }

    function handleError() {
        img.classList.add("lazyload-error");
        img.classList.remove("lazyloading");
        img.closest('.img-spinner')?.classList.remove('img-spinner');
    }
}

{
    const observer = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList" && mutation.addedNodes?.length > 0) {
                mutation.addedNodes.forEach(_ => _.nodeName === 'IMG' && handleImage(_ as HTMLImageElement))
            }
        }
    });
    observer.observe(document, { childList: true, subtree: true });
}